const DARK_CLASS = 'dark';
const HIGH_CONTRAST_CLASS = 'high-contrast';
const DARK_HIGH_CONTRAST_CLASS = 'dark-high-contrast';

export { DARK_CLASS, DARK_HIGH_CONTRAST_CLASS, HIGH_CONTRAST_CLASS };
